// TODO: Add routes to be used in the app in this file for centralized management
export const ROUTES = {
  ROOT: "/",

  // Sign up
  CREATE_ACCOUNT: "/create-account",
  FREEMIUM_SIGNUP: "/freemium-signup",

  // Send verification email 
  FREEMIUM_VERIFICATION_EMAIL: "/freemium-verification-email",

  // Complete sign up after email verification
  FREEMIUM_COMPLETE_SIGNUP: "/freemium-complete-signup",

  // Confirmation page for fremium accounts
  FREEMIUM_CONFIRMATION: "/freemium-confirmation",

  // Sign in
  FORGOT_PASSWORD: "/forgot-password",

  // Account Creation
  COMPANY_INFO: "/company-info",
  CHOOSE_PRICING: "/choose-pricing",
  PENDING_PAYMENT: "/pending-payment",

  // Main
  CANDIDATE_CVS: "/job-match/select-cv",
  SOURCING: "/sourcing"
};
